























import { Component, Vue } from 'vue-property-decorator'
import { UNIT_TABS } from '@/_consts/UnitTab'

@Component({
  components: {},
})
export default class UnitList extends Vue {
  // data
  public unitId: string = ''
  public tabItems = UNIT_TABS
  public selectedTab: string = 'information'

  get isLoading(): boolean {
    return this.$store.state.units.loading
  }

  // After page created
  public created() {
    this.unitId = this.$route.params.unit_id
    this.$store.dispatch('units/getOne', this.unitId)
  }
}
